/* Moments Etched v15.5.1 — Mobile CTA bridge
   The premium product renders a primary Personalize control and a separate
   mobile sticky CTA. Legacy designer code binds the first trigger. Bridge the
   sticky CTA to that proven primary trigger so both entry points behave alike. */
(() => {
  'use strict';

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.me-pp-mobile-cta [data-me-designer-open]');
    if (!trigger) return;

    const primary = document.querySelector('.me-pp-summary__personalize[data-me-designer-open]');
    if (!primary || primary === trigger) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    primary.click();
  }, true);
})();

/* v15.5.8 — On phones each five-stage task must begin at its own top.
   The workspace is now the scrolling surface, so resetting only the legacy
   inner panels is not enough when moving from a long Color screen into
   Placement. Watch the authoritative stage attribute and reset that scroller. */
(() => {
  'use strict';
  const isPhone = () => window.matchMedia('(max-width: 749px)').matches;

  const install = (root) => {
    if (!root || root.dataset.meMobileStageResetBound === 'true') return;
    root.dataset.meMobileStageResetBound = 'true';

    const reset = () => {
      if (!isPhone()) return;
      const workspace = root.querySelector('.me-designer__workspace');
      if (!workspace) return;
      window.requestAnimationFrame(() => {
        workspace.scrollTop = 0;
        try { workspace.scrollTo({ top: 0, left: 0, behavior: 'auto' }); } catch (_) {}
      });
    };

    new MutationObserver((mutations) => {
      if (mutations.some(m => m.type === 'attributes' && m.attributeName === 'data-me-studio-stage')) reset();
    }).observe(root, { attributes: true, attributeFilter: ['data-me-studio-stage'] });
  };

  const boot = () => document.querySelectorAll('[data-me-designer].me-studio-v152').forEach(install);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  new MutationObserver(boot).observe(document.documentElement, { childList: true, subtree: true });
})();
